import React from 'react'
import moment from "moment";
import { DEFAULTIMAGEURL, IMAGEURL } from '../Utils/EndPoint';
const Modal = ({closeModal,user, handleSendInvite}) => {

    return (
    <div>
              <div className="absolute inset-0 bg-black bg-opacity-50 w-100 flex justify-center items-center ">
          <div className="bg-white rounded-lg p-4  ">
            <h3 className="text-lg font-bold mb-4">Select a User</h3>
            <div className="flex flex-col gap-2 overflow-y-auto max-h-[300px]">
               {user.length > 0 ? (             
              user.map((user, index) => (
                <div
                  key={index}
                  className="flex justify-between items-center p-2 border rounded hover:bg-gray-100"
                >
                  <div className="flex items-center gap-3">
                   
                    <img
                      src={user.image ? `${IMAGEURL}/${user.image}` : DEFAULTIMAGEURL}
                      alt={`${user.firstName}'s profile`}
                      className="w-8 h-8 rounded-full object-cover"
                    />
                     <div className='grid'>
                    <span className="font-medium text-gray-900">
                      {user.firstName + " " + user.lastName}
                    </span>
                    <span className="font-medium text-gray-900">
                      {"Created At " +  moment(user.createdAt).format("DD-MM-YY")}
                    </span>
                    </div>
                  </div>
                  <button
                    onClick={() => handleSendInvite(user)}
                    className="bg-green-500 text-white px-3 py-1 text-sm rounded hover:bg-green-600"
                  >
                  Chat
                  </button>
                </div>
              ))
              ): (
              <div> no user found
              </div>
          )
              }
            </div>
            <button
              onClick={() => closeModal()}
              className="mt-4 w-full bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
            >
              Close
            </button>
          </div>
        </div>

    </div>
  )
}

export default Modal
